import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type PeoplePickerConfig} from 'web-app/react/people-picker/types';

const domain = 'MODALS/PEOPLE_PICKER';
export const {action: show} = createAction(`${domain}/SHOW`, (peoplePickerConfig: PeoplePickerConfig) => ({
    peoplePickerConfig,
}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
